import createAxios from '../axiosHttp';
export const administrationService = {
  deleteEntities,
  cancelEntities
};

function deleteEntities(body) {
  const axios = createAxios();
  let urlPath = 'administration/deletes';
  return axios.put(urlPath, body);
}
function cancelEntities(body) {
  const axios = createAxios();
  let urlPath = 'administration/cancels';
  return axios.put(urlPath, body);
}
